module.exports = __webpack_public_path__ + "img/houpai.07d3b13e.png";